import { addImageWidget } from './actions';
const addImageWidgetAction = 'addImageWidget';
export const ImageWidget = (builder, opts) => {
    builder.addAction(addImageWidgetAction, (deps) => addImageWidget(deps, {
        uploadImages: opts.imageUploadHandler,
        needToSetDimensionsForUploadedImages: opts.needToSetDimensionsForUploadedImages,
    }));
};
